import React from 'react';
import './tipoCadastro.scss';

import Breadcrumbs from '../../components/breadcrumbs';
import RadioButton from '../../components/radioButton';
import NavigationButtons from '../../components/navigationButtons';
import userImg from '../../assets/images/person-solid.svg';
import teamImg from '../../assets/images/many-people-solid.svg';
import Form from '../../components/form';
import QueryString from 'query-string';

class TipoCadastro extends React.Component {

  componentWillMount() {
    this.formFields = []
    let { getListTipoProdutoAction, getNavegationStepsAction, configuracaoDdi } = this.props
    getListTipoProdutoAction()
    getNavegationStepsAction()
    configuracaoDdi()
  }

  componentDidMount() {
    const query = QueryString.parse(this.props.location.search);

    if(query.codigo){

      let {
        setDadosIniciaisCodigoGerenteAction,
      } = this.props;

      setDadosIniciaisCodigoGerenteAction(query.codigo, true);
    }
  }


  render() {

    let radioButtonListTipoPessoa = [
      { value: "PessoaFisica", name: 'pessoaFisica', label: "Você", icon: <i className="resumo-icon radio-text-icon"> <img src={userImg} alt="user" /></i> },
      // { value: "PessoaEstrangeira", name: 'pessoaEstrangeira', label: 'Pessoa Física sem CPF' },
      { value: "PessoaJuridica", name: 'pessoaJuridica', label: 'Sua empresa', icon: <i className="resumo-icon radio-text-icon"> <img src={teamImg} alt="user" /></i> }]

    let radioButtonListNecessidade = [
      { value: "EnviarParaExterior", name: 'enviarParaExterior', label: "Mandar valores para o exterior" },
      { value: "ReceberDoExterior", name: 'receberDoExterior', label: 'Receber valores do exterior' }]

    let { tipoPessoaValue, tipoProdutoValue, tipoNecessidade, loadingTipoProduto } = this.props.tipoCadastro;

    let { produtos,
      navegations,
      selecionarTipoPessoaAction,
      refreshTipoContratoAction,
      selecionarTipoNecessidadeAction,
      refreshStepDadosBancario,
      selecionarTipoProdutoAction } = this.props;

    let obj = navegations[tipoPessoaValue];

    return (
      <section className="container cadastroPessoa">
        <div className="col">
          <Breadcrumbs />
        </div>
        <div className=" radioButtons">
          <Form name="form1" onSubmit={this.onSubmitForm} novalidate={true}>
            <RadioButton
              name="tipoPessoaValue"
              label="Criar conta"
              check={tipoPessoaValue}
              required="true"
              onChange={(value) => {
                selecionarTipoPessoaAction(value);
                refreshTipoContratoAction(produtos);
                refreshStepDadosBancario(produtos);
              }}
              dataSource={radioButtonListTipoPessoa}
              returnObject={this.createRefFields}
            />

            <RadioButton
              name="tipoNecessidade"
              label="Qual a sua necessidade?"
              check={tipoNecessidade}
              required="true"
              onChange={(event) => {
                selecionarTipoNecessidadeAction(event);
                refreshTipoContratoAction(produtos);
                refreshStepDadosBancario(produtos);
              }}
              dataSource={tipoPessoaValue ? radioButtonListNecessidade : []}
              returnObject={this.createRefFields}
            />

            <RadioButton
              name="tipoProdutoValue"
              label="Qual seu perfil?"
              check={tipoProdutoValue}
              required="true"
              onChange={(event) => {
                selecionarTipoProdutoAction(event);
                refreshTipoContratoAction(produtos);
                refreshStepDadosBancario(produtos);
              }}

              dataSource={produtos}
              returnObject={this.createRefFields}
              loading={loadingTipoProduto}
            />
          </Form>
        </div>

        <div className="col">
          <NavigationButtons history={this.props.history} mensage={tipoPessoaValue ? obj.Observacao : ''} validateFields={this.validateFields} />
        </div>
      </section>
    );
  }

  createRefFields = (self) => {
    this.formFields[self.props.name] = self
  }

  validateFields = () => {

    let list = []
    let countMounted = 0

    return new Promise(resolve => {
      if (Object.keys(this.formFields).length === 0) {
        resolve([])
      }

      for (let key in this.formFields) {
        if (this.formFields[key]._isMounted) {
          countMounted++
          this.formFields[key].validate(this.formFields[key].input)
            // eslint-disable-next-line no-loop-func
            .then(r => {
              list.push({ name: this.formFields[key].props.name, valid: r })

              if (countMounted === list.length) {
                resolve(list)
              }
            })
        }
      }
    })

  }
}

export default TipoCadastro;
